<template>
    <page-message v-if="saved">
        <template #header>{{t('result.header')}}</template>
        <template #html>
            {{t('result.message')}}
        </template>
        <template #cta>
            <router-link :to="{name:'home'}" class="btn btn-primary">{{$t('navigation.home')}}</router-link>
        </template>
    </page-message>
    <div v-else class="container survey-delivery">
        <div class="row">
            <div class="col-12 offset-lg-2 col-lg-8">
                <div v-if="message" class="text-center pb-4 fw-bold">
                    {{t(message)}}
                </div>
                <form @submit.prevent="submit">
                    <div v-for="group in grouped" class="row product" :key="group.uuid">
                        <div class="col-4 col-lg-3">
                            <form-checkbox v-model="model"
                                           :selected-value="group.uuid"
                                           :disabled="processing"
                                           :label="t('model.checked.label')"/>
                        </div>

                        <div class="col-8 col-lg-9">
                            <survey-delivery-product :value="group.product"/>
                        </div>
                    </div>

                    <div class="mb-3 text-center pt-2">
                        <button type="submit" class="btn btn-sm btn-primary" :disabled="processing">
                            <spinner v-if="processing"/>
                            {{processing ? t('button.submit.processing') : t('button.submit.cta')}}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

    import {v4 as uuidv4} from "uuid";

    import mixin_view from "@/mixins/view";
    import {retryRequest} from "@/helpers/request";

    import Panel from "@/components/Panel";
    import FormCheckbox from "@/components/form/FormCheckbox";
    import PageMessage from "@/components/page/PageMessage";
    import SurveyDeliveryProduct from "@/components/survey/SurveyDeliveryProduct";

    const STATUS_YES = "yes";
    const STATUS_NO = "no";

    export default {
        name: "ViewsSurveyDelivery",
        mixins: [mixin_view],
        components: {
            SurveyDeliveryProduct,
            PageMessage,
            FormCheckbox,
            Panel
        },
        data() {

            return {
                t_path: "views.survey.delivery",
                processing: false,
                saved: false,
                message: null,
                items: [],
                grouped: [],
                model: []
            }
        },
        methods: {
            submit() {

                this.processing = true;

                const references = this.items.map(item => item.reference_id);
                const received = this.model.reduce(
                    (result, uuid) => result.concat(this.grouped.find(item => item.uuid === uuid).references),
                    []
                )

                const request = {
                    order_id: this.$route.query.order_id,
                    delivery_received: received,
                    delivery_not_received: references.filter(referenceId => -1 === received.indexOf(referenceId)),
                };

                return retryRequest(() => this.$delivery.post("/confirm", request))
                    .then(response => {

                        if (response.data.meta.code) {

                            if (-1 !== ["204_shipment_received"].indexOf(response.data.meta.code)) {

                                return this.$router.push({
                                    name: "survey.deliveryfaq",
                                    query: {
                                        reference_ids: request.delivery_not_received.join(","),
                                        itemsReference: this.$route.query.itemsReference
                                    }
                                });
                            }

                            if (-1 !== ["204_delivery"].indexOf(response.data.meta.code)) {

                                return this.$router.push({
                                    name: "survey.customer",
                                    query: {
                                        order_id: this.$route.query.order_id,
                                        reference_ids: this.$route.query.reference_ids,
                                        itemsReference: this.$route.query.itemsReference
                                    }
                                });
                            }
                        }

                        this.saved = true;
                    })
                    .catch(error => {

                        if (!error.response) {

                            return this.$toast.error(this.t("errors.requestError"), {
                                timeout: 5000
                            });
                        }

                        this.base_error(error);
                    })
                    .finally(() => this.processing = false);
            },
            fetch() {

                this.items = this.$session.get(this.$route.query.itemsReference, []);

                // Group items by order id, tracking and product sku
                this.grouped = this.items.reduce(
                    (result, item) => {

                        // check for we already have a group with this product and tracking
                        const index = result.findIndex(resultItem =>
                            resultItem.order_id === item.order_id &&
                            resultItem.tracking === item.tracking &&
                            resultItem.sku === item.sku
                        );

                        if (-1 !== index) {

                            result[index].references.push(item.reference_id);
                            result[index].product.count++;
                        } else {

                            result.push({
                                uuid: uuidv4(),
                                order_id: item.order_id,
                                tracking: item.tracking,
                                sku: item.sku,
                                references: [item.reference_id],
                                product: {
                                    count: 1,
                                    ...item
                                }
                            })
                        }

                        return result;
                    },
                    []
                );

                if (STATUS_YES === this.$route.query.status) {

                    this.grouped.forEach(item => this.model.push(item.uuid));
                    this.message = "status.yes";
                }

                if (STATUS_NO === this.$route.query.status) {

                    this.message = "status.no";
                }
            }
        },
        mounted() {

            this.fetch();
        }
    }
</script>